import { forwardRef } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDDatePickerRoot from "components/MDDatePicker/MDDatePickerRoot";

// MDDatePicker avec la logique de CustomDatePicker intégrée
const MDDatePicker = forwardRef(
    ({ label, value, onChange, minDate, variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow, scale = 0.8, ...rest }, ref) => {
        const datePickerStyles = {
            backgroundColor: bgColor || "#ffffff",  // Fond par défaut
            borderRadius: borderRadius || "8px",    // Bordure par défaut
            boxShadow: shadow || "0px 3px 6px rgba(0, 0, 0, 0.1)", // Ombre par défaut
            width: "160px",  // Largeur personnalisée
            transform: `scale(${scale})`,  // Réduction proportionnelle
            transformOrigin: "top left",  // Garde l'origine de transformation au coin supérieur gauche
            ...rest.sx,  // Fusionner avec d'autres styles si définis
        };

        const slotProps = {
            day: {
                sx: {
                    ":not(.Mui-selected)": {
                        backgroundColor: "#ffffff",
                        borderColor: "#49a3f1"
                    },
                    "&.MuiPickersDay-root.Mui-selected": {
                        color: "#ffffff",
                        backgroundColor: "#49a3f1",
                        borderColor: "#49a3f1",
                        ":hover": {
                            color: "#000000",
                            backgroundColor: "#b7e4fd",
                            borderColor: "#b7e4fd"
                        }
                    },
                    ":hover": {
                        color: "#000000",
                        backgroundColor: "#b7e4fd",
                        borderColor: "#b7e4fd"
                    }
                }
            },
            year: {
                sx: {
                    "&.Mui-selected": {
                        color: "#ffffff",
                        backgroundColor: "#49a3f1",
                        borderRadius: "8px",
                        fontWeight: "bold"
                    },
                    "&:hover": {
                        backgroundColor: "#b7e4fd",
                        color: "#ffffff"
                    }
                }
            }
        };

        return (
            <MDBox display="flex" alignItems="center" gap={0.5}>
                <MDTypography variant="button" fontWeight="light" color="dark" ml={1} fontSize="1rem">
                    {label}:
                </MDTypography>
                <MDDatePickerRoot
                    {...rest}
                    ref={ref}
                    ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow, coloredShadow }}
                    value={value}
                    onChange={onChange}
                    minDate={minDate}
                    sx={datePickerStyles}  // Appliquer les styles consolidés avec rétrécissement
                    slotProps={slotProps}  // Passer les styles pour les jours et les années
                />
            </MDBox>
        );
    }
);

MDDatePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.any,
    variant: PropTypes.string,
    bgColor: PropTypes.string,
    color: PropTypes.string,
    opacity: PropTypes.number,
    borderRadius: PropTypes.number,
    shadow: PropTypes.string,
    coloredShadow: PropTypes.string,
    scale: PropTypes.number,  // Ajouter la prop scale pour ajuster la taille du composant
};

export default MDDatePicker;
